import { useMemo } from 'react';
import useRangeFilter from '@/creditflowresearch/ui/components/corporate-bond-screener/Sidebar/Sections/hooks/useRangeFilter';
import { createRangeSchema } from '@/creditflowresearch/ui/common/hooks/sidebar/rangeSchema';
import {
  useCorporateBondScreenerSidebarFilterContext,
} from '@/creditflowresearch/application/CorporateBondScreener/Sidebar/useCorporateBondScreenerSidebarFilterContext';

const usePricingSpread = () => {
  const { filters } = useCorporateBondScreenerSidebarFilterContext();
  const schema = useMemo(() => createRangeSchema({ bounds: filters?.spread }), [filters?.spread]);

  return useRangeFilter({ fromKey: 'includedPricingSpreadFrom', toKey: 'includedPricingSpreadTo', schema });
};

export default usePricingSpread;
